import { Button } from "./styles";
import Loader from "../Spinner";
interface ButtonProps {
  type?: "button" | "submit" | "reset";
  onClick?: (event?) => void;
  children: any;
  disabled?: boolean;
  forwardref?;
  form?: any;
  loading?: boolean;
  options: {
    type: "filled" | "outline" | "link";
    size: "xs" | "sm" | "md" | "lg" | "xl";
    skin: "primary" | "secondary" | "gray" | "transparent" | "white" | "danger";
    block?: boolean;
    marginBottom?: string;
  };
  style?;
}

const Component = ({
  children,
  loading,
  forwardref,
  type = "button",
  ...rest
}: ButtonProps) => {
  return (
    <Button {...(forwardref && { ref: forwardref })} {...rest} type={type}>
      {loading ? <Loader /> : children}
    </Button>
  );
};

export default Component;
